export const CALCULATOR_VIEWPORT_MODE = {
  DESKTOP: 'desktop',
  MOBILE_PORTRAIT: 'mobile-portrait',
  MOBILE_LANDSCAPE: 'mobile-landscape',
};

export const getCalculatorViewportMode = (width, height) => {
  if (!width || !height) {
    return CALCULATOR_VIEWPORT_MODE.DESKTOP;
  }

  if (width <= 768) {
    return width > height
      ? CALCULATOR_VIEWPORT_MODE.MOBILE_LANDSCAPE
      : CALCULATOR_VIEWPORT_MODE.MOBILE_PORTRAIT;
  }

  if (height <= 500) {
    return CALCULATOR_VIEWPORT_MODE.MOBILE_LANDSCAPE;
  }

  return CALCULATOR_VIEWPORT_MODE.DESKTOP;
};

export const getMobileCalculatorFrame = (mode, width, height, isMinimized) => {
  if (mode === CALCULATOR_VIEWPORT_MODE.MOBILE_PORTRAIT) {
    return {
      width: Math.min(Math.max(width - 24, 280), 420),
      height: isMinimized
        ? 60
        : Math.min(Math.max(Math.round(height * 0.56), 320), Math.max(height - 92, 260), 440),
      align: 'end',
    };
  }

  if (mode === CALCULATOR_VIEWPORT_MODE.MOBILE_LANDSCAPE) {
    return {
      width: isMinimized
        ? Math.min(Math.max(width - 24, 220), 280)
        : Math.min(Math.max(Math.round(width * 0.54), 300), 360),
      height: isMinimized
        ? 60
        : Math.min(Math.max(Math.round(height * 0.92), 220), 320),
      align: 'end',
    };
  }

  return null;
};
